import React from 'react';

import { classnames } from '@lumapps/classnames';
import { Attributes } from '@lumapps/data-attributes';
import { Size, UserBlockSize } from '@lumapps/lumx/react';
import { UserAvatar } from '@lumapps/user/components/UserAvatar';
import { UserBlock } from '@lumapps/user/components/UserBlock';

import { BlockComponent, BlockUser as BlockUserType, BlockUserVariant } from '../../../types/blocks';

import './BlockUser.scss';

interface BlockUserProps extends BlockUserType {
    className?: string;
    avatarSize?: UserBlockSize;
    attributes?: Attributes;
    scope?: string;
}

export const CLASSNAME = 'block-user';

export const BlockUser: BlockComponent<BlockUserProps> = ({
    className,
    userId,
    fullName,
    email,
    variant = BlockUserVariant.regular,
    avatarSize = Size.m as UserBlockSize,
    theme,
    profilePrimaryFieldValues,
    scope,
    attributes,
}) => {
    if (variant === BlockUserVariant.pictureOnly) {
        return (
            <UserAvatar
                user={{
                    id: userId,
                    fullName,
                    email,
                }}
                size={avatarSize}
                scope={scope}
                avatarAs="link"
                showUserCardOnHover
                {...attributes}
            />
        );
    }

    return (
        <UserBlock
            className={classnames(className, CLASSNAME)}
            user={{
                id: userId,
                fullName,
                email,
            }}
            primaryFields={profilePrimaryFieldValues}
            size={avatarSize}
            theme={theme}
            scope={scope}
            {...attributes}
        />
    );
};
